/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Tab_SystemInputs */

const en_notifications_tab_system = /** @type {(inputs: Notifications_Tab_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`System`)
};

const pt_br2_notifications_tab_system = /** @type {(inputs: Notifications_Tab_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sistema`)
};

/**
* | output |
* | --- |
* | "System" |
*
* @param {Notifications_Tab_SystemInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_tab_system = /** @type {((inputs?: Notifications_Tab_SystemInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Tab_SystemInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_tab_system(inputs)
	return pt_br2_notifications_tab_system(inputs)
});